// src/config/sectors.js
// Single source of truth for sector IDs (SubConsultant rows in the backend).
// Replace the Ropeway ID with the real UUID from the backend (Django admin -> SubConsultant).
export const SECTORS = {
    Highway: { id: "9d74ca44-5bff-4ecb-afac-aba5663eb2d0", label: "Highway" },
    Railway: { id: "a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7", label: "Railway" },
    Ropeway: { id: "3baac345-7a2f-48c4-a1f1-7102d5fd921d", label: "Ropeway" },
};

// Sectors whose Sector dropdown is read-only in AddProjectName / UpdateProjectName.
export const LOCKED_SECTORS = ["Highway", "Ropeway"];
export const getLockedSector = (usedFor) =>
    LOCKED_SECTORS.includes(usedFor) ? SECTORS[usedFor] : null;